import type { SVGProps } from "react";
export interface ShopLocationIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShopLocationIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShopLocationIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.876 17.257c0-1.114-.973-2.132-2.126-2.132-1.152 0-2.125 1.018-2.125 2.132v.171l.014.25c.069.584.372 1.19.828 1.779.413.533.9.98 1.283 1.296.384-.317.87-.763 1.283-1.296.522-.673.843-1.37.843-2.029zm-19 .742V10a1.125 1.125 0 0 1 2.25 0v8c0 1.035.839 1.875 1.874 1.875h1.875V18a4.125 4.125 0 0 1 3.945-4.121l.116.001a1.124 1.124 0 0 1-.02 2.247l-.184.017A1.876 1.876 0 0 0 10.125 18v1.875h2.28l.115.005a1.125 1.125 0 0 1 0 2.239l-.115.006H6A4.125 4.125 0 0 1 1.875 18Zm21.25-.57c0 1.368-.648 2.544-1.314 3.405-.676.873-1.464 1.539-1.944 1.909a1.83 1.83 0 0 1-2.235 0c-.48-.37-1.268-1.036-1.944-1.909-.625-.807-1.233-1.89-1.307-3.15l-.007-.256v-.171c0-2.314 1.938-4.382 4.375-4.382s4.376 2.068 4.376 4.382z"
      />
      <path
        fill={color}
        d="m18.76 16.375.114.006a1.125 1.125 0 0 1 0 2.239l-.114.005h-.01a1.125 1.125 0 0 1 0-2.25zm1.06-14.5c.861 0 1.63.52 1.959 1.304l.06.16 1.098 3.357.088.304c.068.276.117.603.087.957l-.028.215c-.363 2.042-2.276 3.453-4.407 3.453-1.287 0-2.503-.524-3.34-1.389-.838.865-2.052 1.389-3.34 1.389s-2.503-.524-3.34-1.389c-.838.865-2.053 1.389-3.34 1.389-2.122 0-4.026-1.399-4.4-3.426-.112-.604.026-1.152.156-1.532l1.141-3.352.062-.158a2.13 2.13 0 0 1 1.95-1.282zM3.203 7.393c-.082.242-.083.353-.075.397.15.815.997 1.585 2.189 1.585 1.34 0 2.216-.95 2.216-1.875a1.125 1.125 0 0 1 2.244-.116l.015.289c.1.867.95 1.702 2.206 1.702 1.34 0 2.215-.95 2.215-1.875a1.125 1.125 0 0 1 2.244-.116l.006.116.01.173c.1.867.948 1.702 2.204 1.702 1.198 0 2.045-.776 2.19-1.595l-.003-.12a1 1 0 0 0-.02-.112l-.045-.153-1.071-3.27H4.315z"
      />
    </svg>
  );
}
